module.exports = __webpack_public_path__ + "img/banner.a83d2a9b.svg";